// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectableTag-module__selectable-tag--z4Map{position:relative;font-weight:700;font-size:11px;color:#000;border-radius:2px;border:1px solid #000;padding:0 5px;line-height:18px;display:inline-block;cursor:pointer;margin-right:10px}.SelectableTag-module__selectable-tag--z4Map:hover{background-color:rgba(7,7,7,.05)}.SelectableTag-module__selectable-tag--z4Map.SelectableTag-module__selected--nOCRs{background-color:#000;color:#fff}.SelectableTag-module__selectable-tag--z4Map .SelectableTag-module__tooltip-info--Rmt5c{top:25px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectable-tag": `SelectableTag-module__selectable-tag--z4Map`,
	"selectableTag": `SelectableTag-module__selectable-tag--z4Map`,
	"selected": `SelectableTag-module__selected--nOCRs`,
	"tooltip-info": `SelectableTag-module__tooltip-info--Rmt5c`,
	"tooltipInfo": `SelectableTag-module__tooltip-info--Rmt5c`
};
export default ___CSS_LOADER_EXPORT___;
